















import ImageListItem from '@/component/view/ImageListItem.vue';
import { FeedModel } from '@/type/api';
import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CONSTANTS } from '@/core';
import { getMediasFromFeedData } from '@/util';

@Component<ImageList>({
  components: {
    ImageListItem,
  },
})
export default class ImageList extends Vue {
  @Prop({ type: Array })
  feeds!: FeedModel.Read.Response.Feed[];

  @Prop({ type: Number })
  pageID!: number;

  @Prop({ type: String, default: '' })
  sectionTitle!: string;

  get title() {
    return this.pageID === 1 ? this.sectionTitle : null;
  }

  getMediaDefFromFeed(feed: FeedModel.Read.Response.Feed): FeedModel.MediaFromFeed {
    const medias = getMediasFromFeedData(feed);
    return medias.length > 0
      ? medias[0]
      : {
          file_nm: 'dummyImage.png',
          file_id: 'dummy',
          url: CONSTANTS.UNKNOWN_IMAGE_PATH,
          type: 'image',
        };
  }
}
